import { Box } from '@chakra-ui/react';

import { dateTimeBodyRender } from '../../common/table/body-renders/date-time';
import { userBodyRender } from '../../common/table/body-renders/user';

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    name: 'id',
    label: '#',
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: 'create_dt',
    label: 'Дата/время',
    options: {
      filter: {
        name: 'create_dt',
        type: 'date',
        onApply: (value: string) => value + 'T00:00:00',
      },
      sort: true,
      customBodyRender: dateTimeBodyRender(),
    },
  },
  {
    name: 'user',
    label: 'Пользователь',
    options: {
      filter: true,
      sort: true,
      customBodyRender: userBodyRender(),
    },
  },
  {
    name: 'json_data',
    label: 'Данные (json)',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value: unknown) => (
        <Box whiteSpace='pre-wrap' maxWidth={500}>{JSON.stringify(value)}</Box>
      ),
    },
  },
];
